
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/employee-requests/[employeeRequestOrderId]/receive-payment",
      function () {
        return require("private-next-pages/admin/employee-requests/[employeeRequestOrderId]/receive-payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/employee-requests/[employeeRequestOrderId]/receive-payment"])
      });
    }
  